export function isDashboardManagementAuthority (value) {
  const normalized = String(value || '').trim().toLowerCase()
  return normalized === 'admin' || normalized === 'clerk'
}

export function formatInsightMinutes (value) {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue) || numericValue <= 0) return '00:00'

  const rounded = Math.max(0, Math.round(numericValue))
  const hours = Math.floor(rounded / 60)
  const minutes = String(rounded % 60).padStart(2, '0')
  return `${String(hours).padStart(2, '0')}:${minutes}`
}

export function formatInsightWorkDays (value) {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue) || numericValue <= 0) return '0'

  return Number.isInteger(numericValue)
    ? String(numericValue)
    : numericValue.toFixed(1)
}

export function formatInsightYearMonth (value) {
  const text = String(value || '')
  if (!/^\d{6}$/.test(text)) return text
  return `${text.substring(0, 4)}年${Number(text.substring(4, 6))}月`
}

export function clampInsightPercent (value) {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) return 0
  return Math.min(100, Math.max(0, numericValue))
}

export function documentStatusTone (status, waitingDays = 0, applicable = true) {
  if (applicable === false) return 'excluded'
  if (String(status) === '4') return 'approved'
  if (String(status) === '3') return 'rejected'
  if (String(status) === '2' && Number(waitingDays) >= 3) return 'overdue'
  if (String(status) === '2') return 'pending'
  return 'unsubmitted'
}
